/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type BulkRepublishPaymentNotificationsRequest,
    BulkRepublishPaymentNotificationsRequestFromJSON,
    BulkRepublishPaymentNotificationsRequestToJSON,
} from '../models/BulkRepublishPaymentNotificationsRequest';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';

export interface BulkRepublishCardDataNotificationsRequest {
    bulkRepublishPaymentNotificationsRequest: BulkRepublishPaymentNotificationsRequest;
}

export interface BulkRepublishPaymentNotificationsOperationRequest {
    bulkRepublishPaymentNotificationsRequest: BulkRepublishPaymentNotificationsRequest;
}

export interface RepublishCardDataNotificationsRequest {
    paymentReference: string;
}

export interface RepublishPaymentNotificationsRequest {
    paymentReference: string;
}

/**
 * 
 */
export class PaymentNotificationControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for bulkRepublishCardDataNotifications without sending the request
     */
    async bulkRepublishCardDataNotificationsRequestOpts(requestParameters: BulkRepublishCardDataNotificationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bulkRepublishPaymentNotificationsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkRepublishPaymentNotificationsRequest',
                'Required parameter "bulkRepublishPaymentNotificationsRequest" was null or undefined when calling bulkRepublishCardDataNotifications().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payment-notifications/card-data/bulk-republish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkRepublishPaymentNotificationsRequestToJSON(requestParameters['bulkRepublishPaymentNotificationsRequest']),
        };
    }

    /**
     */
    async bulkRepublishCardDataNotificationsRaw(requestParameters: BulkRepublishCardDataNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.bulkRepublishCardDataNotificationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async bulkRepublishCardDataNotifications(requestParameters: BulkRepublishCardDataNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bulkRepublishCardDataNotificationsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for bulkRepublishPaymentNotifications without sending the request
     */
    async bulkRepublishPaymentNotificationsRequestOpts(requestParameters: BulkRepublishPaymentNotificationsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bulkRepublishPaymentNotificationsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkRepublishPaymentNotificationsRequest',
                'Required parameter "bulkRepublishPaymentNotificationsRequest" was null or undefined when calling bulkRepublishPaymentNotifications().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payment-notifications/bulk-republish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkRepublishPaymentNotificationsRequestToJSON(requestParameters['bulkRepublishPaymentNotificationsRequest']),
        };
    }

    /**
     */
    async bulkRepublishPaymentNotificationsRaw(requestParameters: BulkRepublishPaymentNotificationsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.bulkRepublishPaymentNotificationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async bulkRepublishPaymentNotifications(requestParameters: BulkRepublishPaymentNotificationsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bulkRepublishPaymentNotificationsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for republishCardDataNotifications without sending the request
     */
    async republishCardDataNotificationsRequestOpts(requestParameters: RepublishCardDataNotificationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling republishCardDataNotifications().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['paymentReference'] != null) {
            queryParameters['paymentReference'] = requestParameters['paymentReference'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payment-notifications/card-data/republish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async republishCardDataNotificationsRaw(requestParameters: RepublishCardDataNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.republishCardDataNotificationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async republishCardDataNotifications(requestParameters: RepublishCardDataNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.republishCardDataNotificationsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for republishPaymentNotifications without sending the request
     */
    async republishPaymentNotificationsRequestOpts(requestParameters: RepublishPaymentNotificationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling republishPaymentNotifications().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['paymentReference'] != null) {
            queryParameters['paymentReference'] = requestParameters['paymentReference'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payment-notifications/republish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async republishPaymentNotificationsRaw(requestParameters: RepublishPaymentNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.republishPaymentNotificationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async republishPaymentNotifications(requestParameters: RepublishPaymentNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.republishPaymentNotificationsRaw(requestParameters, initOverrides);
    }

}
